
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <div v-if="form.filters.analitico">
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="4">
                        <v-text-field
                        label="Público Alvo"	
                        v-model="form.filters.publicoAlvo"
                        outlined
                        dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        label="Formação"
                        v-model="form.filters.formacao"	
                        outlined
                        dense
                        ></v-text-field>
                    </v-col>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioAnalitico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        v-model="form.filters.dataFimAnalitico"
                        label="Data Final"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                </v-row>
            </div>
            <div v-else>
                <v-row class="d-flex justify-center mt-3">
                    <v-col cols="4">
                        <v-text-field
                        label="Público Alvo"	
                        v-model="form.filters.publicoAlvoSintetico"
                        outlined
                        dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                        label="Formação"
                        v-model="form.filters.formacaoSintetico"	
                        outlined
                        dense
                        ></v-text-field>
                    </v-col>
                    <sigfoco-switch-button
                        :cols="2"
                        v-model="form.filters.analitico"
                        label="Tipo de Relatório"
                        labelChecked="Analítico"
                        labelUnchecked="Sintético"
                    ></sigfoco-switch-button>
                </v-row>
                <v-row class="d-flex justify-center mt-3">
                    <sigfoco-date-picker
                        :cols="2"
                        label="Data Início"
                        v-model="form.filters.dataInicioSintetico"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                    <sigfoco-date-picker
                        :cols="2"
                        v-model="form.filters.dataFimSintetico"
                        label="Data Final"
                        removeIcon
                        outlined
                        dense
                    ></sigfoco-date-picker>
                </v-row>
            </div>
            <div class="text-center">
                <v-col cols="12">
                    <sigfoco-tooltip
                        text="Buscar"
                        icon="mdi-magnify"
                        @click="buscarRelatorios"
                    ></sigfoco-tooltip>
                    <sigfoco-tooltip
                        text="Limpar"
                        icon="mdi-eraser"
                        @click="resetForm"
                    ></sigfoco-tooltip>
                </v-col>
            </div>
        </v-form>
        <v-data-table
          v-if="form.mostrarAnalitico"
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorioAnalitico"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
        >
          <template v-slot:[`item.publicoAlvo`]="{ item }">
            {{ item.publicoAlvo }}
          </template>
          <template v-slot:[`item.formacao`]="{ item }">
            {{ item.formacao }}
          </template>
          <template v-slot:[`item.cargaHoraria`]="{ item }">
            {{ item.cargaHoraria }}
          </template>
        </v-data-table>
        <v-data-table
            v-else
            class="mt-5 printable"
            :headers="getFilteredHeader(headersSintetico)"
            :items="form.lists.listRelatorioSintetico"
            :items-per-page="form.itemsPerPage"
            :footer-props="$footerProps"
            :sort-desc="true"
            show-expand
            item-key="formacao"
            :expanded.sync="expanded"
        >
            <template v-slot:[`item.publicoAlvoSintetico`]="{ item }">
            {{ item.publicoAlvoSintetico }}
            </template>
            <template v-slot:[`item.qtdFormacoes`]="{ item }">
            {{ item.qtdFormacoes }}
            </template>
            <template v-slot:[`item.qtdPrevistas`]="{ item }">
            {{ item.qtdPrevistas }}
            </template>
            <template v-slot:[`item.qtdPresentes`]="{ item }">
            {{ item.qtdPresentes }}
            </template>
            <template v-slot:[`item.qtdAusentes`]="{ item }">
            {{ item.qtdAusentes }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td class="publicoAlvo" :colspan="headers.length">
                <v-chip-group active-class="primary--text" column>
                    <v-chip 
                        class="chip-permissao" 
                        v-for="(formacao,  i) in item.formacoes" :key="i">
                        {{ formacao.nome }}
                    </v-chip>
                </v-chip-group>
                </td>
            </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorioAnalitico.length > 0 || form.lists.listRelatorioSintetico.length > 0"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
import RelatorioSinteticoAnalitico from "services/relatorios-sintetico-analiticos/solicitacao-formacao.service";
import ManterSetorService from "~/services/manter-setor.service";
import FormacaoService from "~/services/manter-formacao.service";    
import DisciplinaService from "~/services/manter-disciplina.service";    
export default {
    name: "RelatorioSolicitacaoFormacaoPorEscola",
    mixins: [pageLoadingMixin, RelatorioSinteticoAnalitico, ManterSetorService, FormacaoService, DisciplinaService],
    data: () => ({
    onReport: false,
    expanded: [],
    form: {
        filters: {
            analitico: true,
            // analitico
            publicoAlvo: null,
            formacao: null,
            dataInicioAnalitico: null,
            dataFimAnalitico: null,
            // sintetico
            publicoAlvoSintetico: null,
            formacaoSintetico: null,
            dataInicioSintetico: null,
            dataFimSintetico: null,
        },
        lists: {
            listRelatorioAnalitico: [],
            listRelatorioSintetico: [],
            listaDisciplinas: [],
        },
        itemsPerPage: 10,
        geradorRelatorio: null,
        horaDaGeracao: null,
        totalSolicitacaoFormacao: 0,
        mostrarAnalitico: true,
    },
    headersAnalitico: [
        { text: "Público Alvo", align: "center", value: "publicoAlvo" },
        { text: "Formação", align: "center", value: "formacao" },
        { text: "Carga Horária", align: "center", value: "cargaHoraria" },
    ],
    headersSintetico: [
        { text: "Público Alvo", align: "center", value: "publicoAlvo" },
        { text: "Formação", align: "center", value: "data-table-expand", onlyView: true },
        { text: "Formação", align: "center", value: "data-table-expand", onlyReport: true },
        { text: "Quantidade de Formações", align: "center", value: "qtdFormacoes" },
        { text: "Quantidade Prevista de Participantes", align: "center", value: "qtdPrevistas" },
        { text: "Quantidade de Participantes Presentes", align: "center", value: "qtdPresentes" },
        { text: "Quantidade de Participantes Ausentes", align: "center", value: "qtdAusentes" },
    ],
    }),
    watch: {
        "form.filters.analitico"(novoValor) {
            this.form.mostrarAnalitico = novoValor;
            this.resetForm();
        }
    },

    computed: {
        isAnalitico() {
            return this.form.filters.analitico;
        },
    },
    methods: {
    getFilteredHeader(headers) {
        return headers.filter(header => {
        if (header.onlyView) return !this.onReport;
        if (header.onlyReport) return this.onReport;
        return true;
        });
    },
    buscarRelatorios() {
        const isValid = this.validarDatas();
        if (!isValid) return;
        const preparedRequest = this.prepararRequisicao();
            const buscarRelatorio = (request) => {
            return this.$obterRelatorioAnaliticoFormacoesPorPublicoAlvo(request);
            };
            buscarRelatorio(this.$montarParamsFilters(preparedRequest)).then(
            ({ data }) => {
                this.form.mostrarAnalitico = this.isAnalitico;
                this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
                this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
                this.isAnalitico ? this.form.lists.listRelatorioAnalitico = data.relatorio?.listaAnalitico : this.form.lists.listRelatorioSintetico = data.relatorio?.listaSintetico; 
            }
        );
    },
    validarDatas() {
        const { dataInicioAnalitico, dataFimAnalitico, dataInicioSintetico, dataFimSintetico } = this.form.filters;
        const msgData = "A Data Início precisa ser anterior ou igual à Data Final";
        if (dataInicioAnalitico && dataFimAnalitico) {
            if (new Date(dataInicioAnalitico) > new Date(dataFimAnalitico)) {
                this.$notifyWarning(msgData);
                return false;
            }
        }
        if (dataInicioSintetico && dataFimSintetico) {
            if (new Date(dataInicioSintetico) > new Date(dataFimSintetico)) {
                this.$notifyWarning(msgData);
                return false;
            }
        }

        return true;
    },
    async baixarCSVRelatorio() { 
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
            const { data } = await (this.$obterRelatorioAnaliticoCSVFormacoesPorPublicoAlvo(this.$montarParamsFilters(preparedRequest))
            );
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeDeFormaçãoPorPublicoAlvo`);
            this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
            this.hidePageLoading();
        }
    },

    async baixarRelatorioPdf() {
        const preparedRequest = this.prepararRequisicao();
        this.showPageLoading();
        try {
            const { data } = await (this.$obterRelatorioAnaliticoPDFFormacoesPorPublicoAlvo(this.$montarParamsFilters(preparedRequest)));

            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeFormaçõesPorPublicoAlvo.pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
            this.hidePageLoading();
        }
    },

    prepararRequisicao() {
        if (this.isAnalitico) {
        return {
            publicoAlvo: this.form.filters.publicoAlvo,
            formacao: this.form.filters.formacao,
            dataInicio: this.form.filters.dataInicioAnalitico,
            dataFim: this.form.filters.dataFimAnalitico,
            isAnalitico: this.isAnalitico,
        };
        } else {
        return {
            publicoAlvo: this.form.filters.publicoAlvoSintetico,
            formacao: this.form.filters.formacaoSintetico,
            disciplinaId: this.form.filters.disciplinaSintetico,
            dataInicio: this.form.filters.dataInicioSintetico,
            dataFim: this.form.filters.dataFimSintetico,
            isAnalitico: this.isAnalitico,
        };
        }
    },
    resetForm() {
        this.form.filters.dataInicioAnalitico = null;
        this.form.filters.dataFimAnalitico = null;
        this.form.filters.dataInicioSintetico = null;
        this.form.filters.dataFimSintetico = null;

        this.$nextTick(() => {
        this.$set(this.form.filters, 'dataInicioAnalitico', null);
        this.$set(this.form.filters, 'dataFimAnalitico', null);
        this.$set(this.form.filters, 'dataInicioSintetico', null);
        this.$set(this.form.filters, 'dataFimSintetico', null);
        });
        // analitico
        this.form.filters.publicoAlvo = null;
        this.form.filters.formacao = null;
        // sintetico
        this.form.filters.publicoAlvoSintetico = null;
        this.form.filters.formacaoSintetico = null;
        this.form.lists.listRelatorioAnalitico = [];
        this.form.lists.listRelatorioSintetico = [];
        this.expanded = [];
    }
    },
};
</script>
<style scoped>
.publicosAlvos {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.publicosAlvo {
  padding-right: 0.5em;
}
</style>